/* eslint-disable */


var _template = require('lodash.template');

var source = '<div data-component="alert" data-type="${type}" data-alignment="">\
                    <button type="button" class="first-of-type">${accept}</button>\
                    <h4>${title}</h4>\
                    <p>${description}</p>\
                    <button type="button" class="last-of-type">${accept}</button>\
                </div>';



/**
    @constructor
    @param {UIAlert.Type} type
    @param {string} title
    @param {string} description
    @description UIAlert calls out underlying page elements, UIMessage is an in-line page element
*/
function UIAlert(type, title, description, accept) {
    var params = {
        type : type,
        title : title || "",
        description : description || "",
        accept : (UIAlert.Type.WARNING || UIAlert.Type.ERROR) ? "Close x" : "Got it"
    };
    var element = document.createElement("DIV");
    element.innerHTML = _template(source)(params);
    this.__hostElement = element.firstChild;
}
UIAlert.prototype = {
    /** @type {Element} */
    __hostElement : null,
    /** @type {Function} */
    __onCloseCallback : null,

    /** @param {HTMLElement} target The HTML element to callout
        @param {UIAlert.Alignment} alignment
        @returns {void} */
    show: function (target, alignment) {
        //document.body.appendChild(this.__hostElement);

        target.parentElement.insertBefore(this.__hostElement, target.parentElement.firstChild);
        this.__hostElement.setAttribute("data-alignment", alignment);

        var top, left;
        var width = $(target).outerWidth();

        var targetOffset = $(target).position();
        switch (alignment) {
          case UIAlert.Alignment.TOP:
            top = targetOffset.top - ALIGNMENT_OFFSET;
            left = targetOffset.left;
            break;
          case UIAlert.Alignment.BOTTOM:
            top = targetOffset.top + $(target).height() + ALIGNMENT_OFFSET;
            left = targetOffset.left;
            break;
          case UIAlert.Alignment.LEFT:
            //we want to align the center of the callout with the center of the target
            top = targetOffset.top - $(this.__element).height() / 2 + $(target).height() / 2;
            left = targetOffset.left - targetOffset.width - ALIGNMENT_OFFSET;
            break;
          case UIAlert.Alignment.RIGHT:
            top = targetOffset.top - $(this.__element).height() / 2 + $(target).height() / 2;
            left = targetOffset.left + targetOffset.width + ALIGNMENT_OFFSET;
            break;
          case UIAlert.Alignment.NONE:
            top = undefined;
            left = undefined;
            width = undefined;
            break;
        }

        $(this.__hostElement).show();
        $(this.__hostElement).css({
                "width" : width +"px",
                "max-width" : width +"px",
                "top" : top +"px",
                "left" : left +"px"
            });

        $(this.__hostElement).find("button[type='button']").click(this.close.bind(this));

    },

    close : function(){
        this.__hostElement.parentNode.removeChild(this.__hostElement);
        this.onclose();
    },

    onclose : function(){
        if (this.__onCloseCallback && typeof this.__onCloseCallback == "function") {
            this.__onCloseCallback();
        }
    },

    setOnCloseCallback : function(onCloseCallback) {
        this.__onCloseCallback = onCloseCallback;
    }
}

UIAlert.Type = {
    SUCCESS : "SUCCESS",
    INFO : "INFO",
    WARNING : "WARNING",
    WARNING_MESSAGE : "WARNING_MESSAGE",
    ERROR : "ERROR"
}

UIAlert.Alignment = {
    TOP : "TOP",
    RIGHT : "RIGHT",
    BOTTOM : "BOTTOM",
    LEFT : "LEFT",
    NONE : "NONE"
}

var ALIGNMENT_OFFSET = 10;    // Additional pixels to offset position based on the :before value of the element

module.exports = UIAlert;
